module.exports = __webpack_public_path__ + "img/jm.e3dacf9e.svg";